import { Button } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

import { useSaveQuestions } from '../../contexts/SaveQuestions'
import { EvaluationSteps } from '../../constants'
import styles from './Buttons.module.scss'

interface Step {
  label: string
  step: EvaluationSteps
}

const STEP_BUTTONS: Step[] = [
  {
    label: 'details',
    step: EvaluationSteps.DETAILS,
  },
  {
    label: 'questions',
    step: EvaluationSteps.QUESTIONS,
  },
  {
    label: 'qualification',
    step: EvaluationSteps.CONFIG,
  },
]

export const Buttons = () => {
  const { t } = useTranslation()

  const { onSaveAndChangeStep, step: currentStep } = useSaveQuestions()

  const handleGoToStep = (newStep: number) => {
    onSaveAndChangeStep(newStep)
  }

  return (
    <>
      {STEP_BUTTONS.map(({ label, step }, i) => (
        <div
          key={step}
          id={`step-${step}-button`}
          className={styles.stepButtons}
        >
          <Button
            variant="outline-primary"
            className={'mt-3 text-left w-100'}
            active={step === currentStep}
            disabled={step === currentStep}
            onClick={() => handleGoToStep(step)}
          >
            {`${i + 1}. ${t(
              `administration.blocks.type.evaluation.navbar.${label}`
            )}`}
          </Button>
        </div>
      ))}
    </>
  )
}
